import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_TITLE = 'Sanjoy.ai';

const ROUTE_TITLES: Record<string, string> = {
  '/': 'Enterprise Intelligence Platform',
  '/industries': 'Industries',
  '/goals': 'Business Goals',
  '/knowledge': 'Knowledge',
  '/workflows': 'Workflows',
  '/products': 'Products',
  '/ask': 'Ask Sanjoy',
  '/search': 'Search',
  '/about': 'About',
  '/team': 'Team',
  '/associate-program': 'Associate Program',
  '/career': 'Associate Program',
  '/partners': 'Partners',
  '/resources': 'Resources',
  '/login': 'Sign In',
  '/profile': 'Profile',
  '/admin': 'Admin Dashboard',
};

export function useDocumentTitle(customTitle?: string) {
  const { pathname } = useLocation();

  useEffect(() => {
    const title = customTitle ?? ROUTE_TITLES[pathname];
    document.title = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;
  }, [pathname, customTitle]);
}
